// Landmark hero photos for /travel/{city} pages and the homepage "Top destinations" block.
const RAW = {
  paris: "https://images.unsplash.com/photo-1511739001486-6bfe10ce785f",
  london: "https://images.unsplash.com/photo-1663669774114-829142d07a83",
  rome: "https://images.unsplash.com/photo-1552832230-c0197dd311b5",
  dubai: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
  tokyo: "https://images.unsplash.com/photo-1565618754154-c8011e5df2a6",
  barcelona: "https://images.unsplash.com/photo-1583422409516-2895a77efded",
  "new-york": "https://images.unsplash.com/photo-1496588152823-86ff7695e68f",
  istanbul: "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200",
  lisbon: "https://images.unsplash.com/photo-1697748525265-7431cba075b6",
  amsterdam: "https://images.unsplash.com/photo-1584003564911-a7a321c84e1c",
  marrakech: "https://images.unsplash.com/photo-1548018560-4cb48a8837c1",
  "cancún": "https://images.unsplash.com/photo-1630252421399-ddde79af47b3",
  cancun: "https://images.unsplash.com/photo-1630252421399-ddde79af47b3",
  bangkok: "https://images.unsplash.com/photo-1779419183239-25222afb3b26",
  singapore: "https://images.unsplash.com/photo-1727859146476-c60c7f8f9764",
  "los-angeles": "https://images.unsplash.com/photo-1597982087634-9884f03198ce",
  vienna: "https://images.unsplash.com/photo-1653384889067-7376de3b167d",
  venice: "https://images.unsplash.com/photo-1584211022290-ee43ea4955ac",
  prague: "https://images.unsplash.com/photo-1519677100203-a0e668c92439",
  sydney: "https://images.unsplash.com/photo-1624138784614-87fd1b6528f8",
  bali: "https://images.unsplash.com/photo-1555400038-63f5ba517a47",
  florence: "https://images.unsplash.com/photo-1527875524146-ed85a131c44d",
  "hong-kong": "https://images.unsplash.com/photo-1533029030467-904d7bbd602b",
  madrid: "https://images.unsplash.com/photo-1543783207-ec64e4d95325",
  athens: "https://images.unsplash.com/photo-1603565816030-6b389eeb23cb",
  berlin: "https://images.unsplash.com/photo-1560969184-10fe8719e047",
  santorini: "https://images.unsplash.com/photo-1571765389054-221ebc7cd3cb",
  "cape-town": "https://images.unsplash.com/photo-1588455471455-4b28e9ab3cd5",
  "rio-de-janeiro": "https://images.unsplash.com/photo-1518639192441-8fce0a366e2e",
  "mexico-city": "https://images.unsplash.com/photo-1759255259985-6f8c71ebe64c",
  phuket: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a",
  "kuala-lumpur": "https://images.unsplash.com/photo-1597148543182-830ef7bbb904",
  cairo: "https://images.unsplash.com/photo-1553913861-c0fddf2619ee",
  miami: "https://images.unsplash.com/photo-1688085320867-5a5aaa96ca8d",
  seoul: "https://images.unsplash.com/photo-1758509444769-95567facc5b0",
};

const FALLBACK = "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1";

export function cityImage(slug, w = 1200, fallbackUrl = "") {
  if (!RAW[slug] && fallbackUrl) return fallbackUrl;
  const base = RAW[slug] || FALLBACK;
  return `${base}?auto=format&fit=crop&w=${w}&q=80`;
}

export const hasCityImage = (slug) => Boolean(RAW[slug]);
